/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { capitalizeFirst } from '@/utils/capitalizeWord';

type OutputPromptDispalyProps = {
  outputRole: string;
  outputString: string;
};

export const OutputPromptDispaly = ({
  outputRole,
  outputString,
}: OutputPromptDispalyProps) => {
  return (
    <div className="flex flex-col">
      <span className="text-form-input-disabled">
        {capitalizeFirst(outputRole)}
      </span>
      <span className="mt-0.5">{outputString}</span>
    </div>
  );
};
